import LoyaltyRewards from 'pages/loyalty/loyalty-rewards/loyalty-rewards';
import { LoyaltyRewardsTabs } from 'pages/loyalty/loyalty-rewards/loyalty-rewards-tabs';

export default function RedeemTab() {
  return (
    <>
      <LoyaltyRewardsTabs />
      <LoyaltyRewards />
    </>
  );
}
